import { motion } from 'framer-motion';

export default function Step4({
  formData,
  setFormData,
  errors,
  prevStep,
  handleChange,
  handleFinish,
  loading,
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: 'easeOut' }}
      className="h-[400px] overflow-y-auto overflow-x-hidden"
    >
      <motion.h2
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2, duration: 0.6 }}
        className="text-2xl font-bold text-gray-900 mb-2"
      >
        Get Started
      </motion.h2>

      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3, duration: 0.6 }}
        className="text-sm font-semibold text-gray-700 mb-1"
      >
        You’re ready to explore uLegal.ai — your legal AI workspace awaits.
      </motion.p>

      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.4, duration: 0.6 }}
        className="text-sm italic text-gray-500 mb-6"
      >
        You can edit your profile anytime from Settings.
      </motion.p>

      <motion.form
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5, duration: 0.6 }}
        className="space-y-4"
      >
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            How did you hear about us?
          </label>
          <select
            name="heardAbout"
            value={formData.heardAbout}
            onChange={(e) => handleChange('heardAbout', e.target.value)}
            className="w-full border border-gray-300 rounded px-4 py-3 focus:ring-2 focus:ring-brand focus:outline-none"
          >
            <option value="">Select one...</option>
            <option value="Google">Google Search</option>
            <option value="Social Media">Social Media</option>
            <option value="Referral">Referral</option>
          </select>

          {errors.heardAbout && (
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.4 }}
              className="text-red-500 text-xs mt-1"
            >
              {errors.heardAbout}
            </motion.p>
          )}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6, duration: 0.6 }}
          className="flex justify-end gap-3 mt-6"
        >
          <motion.button
            type="button"
            onClick={prevStep}
            className="w-28 py-2 border border-brand text-brand rounded hover:bg-indigo-50 transition font-medium"
          >
            Back
          </motion.button>

          <motion.button
            type="button"
            onClick={handleFinish}
            disabled={loading}
            className={`w-36 py-2 rounded transition font-medium 
              ${
                loading
                  ? 'bg-gray-400 cursor-not-allowed'
                  : 'bg-gradient-to-r from-brandDark to-brand text-white hover:bg-indigo-700'
              }`}
            whileHover={!loading ? { scale: 1.01 } : {}}
            whileTap={!loading ? { scale: 0.95 } : {}}
          >
            {loading ? (
              <span className="flex items-center justify-center">
                <svg
                  className="animate-spin h-4 w-4 mr-2 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  />
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                  />
                </svg>
                Processing...
              </span>
            ) : (
              'Get Started'
            )}
          </motion.button>
        </motion.div>
      </motion.form>
    </motion.div>
  );
}
